import $ from 'jquery';
import {BaseCheckout} from "./base-checkout";
import {DestinationNotAvailableModal} from "./destination-not-available-modal";
import {AddressConfirmationModal} from "./address-confirmation-modal";
import {PhoneConfirmationModal} from "./phone-confirmation-modal";
import {SubRegionSelect} from "./subregion-select";
import {PhoneInput} from "./phone-input-sm";

export class CheckoutForm extends BaseCheckout {
	constructor (element, cart, ajaxURL) {
		super(element, cart, ajaxURL);

        if (this.cart) {
            this.cart.checkoutForm = this; // link so the cart can post updates to the server
        }

        this.lastRequestIndex = 0;

        this.showLoading();

		this.shippingAddressFieldsContainer = this.element.find('#shippingAddressFields');
		
		this.issueBusinessInvoiceCheckbox = this.element.find('#issueBusinessInvoiceCheckbox');
		this.invoiceAddressFieldset = this.element.find('#invoiceFields');
		this.invoiceAddressFieldsetContainer = this.invoiceAddressFieldset.parent();
		this.issueBusinessInvoiceCheckbox.change(this.updateInvoiceFieldsVisibility.bind(this));
		
		this.shippingCountrySelect = this.shippingAddressFieldsContainer.find('select.country-select');
		this.invoiceCountrySelect = this.invoiceAddressFieldset.find('select.country-select');
		
		this.shippingCountrySelect.change(this.onShippingCountryChanged.bind(this));
		this.invoiceCountrySelect.change(this.onInvoiceCountryChanged.bind(this));
		
		this.shippingSubRegionSelect = new SubRegionSelect(this.element.find('.subregion-select.shipping'));
		this.shippingSubRegionSelect.setCountry(this.shippingCountrySelect.val());
		
		this.invoiceSubRegionSelect = new SubRegionSelect(this.element.find('.subregion-select.company'));
		this.invoiceSubRegionSelect.setCountry(this.invoiceCountrySelect.val());
		
		this.shippingPhoneInput = new PhoneInput($('#inpShippingPhone'));
		this.shippingPhoneInput.setCountry(this.shippingCountrySelect.val());
		
		this.shippingPostalCodeInput = $('#inpShippingZip');
		this.shippingPostalCodeInput.on('change input paste keyup', this.onPostalCodeChanged.bind(this));

        this.shippingDataContainer = $('#shipping-data-container');
		
		this.updateInvoiceFieldsVisibility();
		
		this.initModalPopups();

		this.updateCountrySpecificFieldsDisplay();

        this.syncCartWithServer(true).then(() => {
            this.hideLoading();
        });
	}

    initModalPopups() {
        this.addressConfirmationModal = new AddressConfirmationModal($('#address-confirmation-modal'));
        this.phoneConfirmationModal = new PhoneConfirmationModal($('#phone-confirmation-modal'));
        this.destinationNotAvailableModal = new DestinationNotAvailableModal($('#destination-not-available-modal'));
    }
	
	updateCountrySpecificFieldsDisplay() {
		this.element.find('.country-specific').css('display', '').find('input').attr('disabled', true);

        const selectedCountryCode = this.shippingCountrySelect.find('option:selected').val();
        if (selectedCountryCode) {
			this.element.find('.country-specific.' + selectedCountryCode).css('display', 'block').find('input').attr('disabled', false);
		}
	}
	
	onShippingCountryChanged(event) {
		let country = this.shippingCountrySelect.val();
        this.shippingSubRegionSelect.setCountry(country);
		this.shippingPhoneInput.setCountry(country);
        this.showLoading();
        this.updateCountrySpecificFieldsDisplay();
		this.syncCartWithServer(false).then(() => {
            this.hideLoading();
        }).catch(() => {
            this.hideLoading();
        });
	}

	onPostalCodeChanged(event) {
        if (this.couriersVaryPerPostCodePrefix) {
            this.syncCartWithServer(false).catch(() => {}).then(() => {
            });
        }
	}
	
	onInvoiceCountryChanged(event) {
		this.invoiceSubRegionSelect.setCountry(this.invoiceCountrySelect.val());
	}

	issueBusinessInvoice() { return this.issueBusinessInvoiceCheckbox.is(':checked'); }
	
	updateInvoiceFieldsVisibility(event) {
		if (this.issueBusinessInvoice()) {
			if (this.invoiceAddressFieldset.parent().length === 0)
				this.invoiceAddressFieldsetContainer.append(this.invoiceAddressFieldset);
			this.invoiceAddressFieldset.css('display', '');
		} else {
			if (this.invoiceAddressFieldset.parent().length > 0)
				this.invoiceAddressFieldset.detach();
			this.invoiceAddressFieldset.css('display', 'none');
		}
	}
	
	async checkPhoneNumberValid() {
		if (this.shippingPhoneInput.isValid()) {
			return true;
		}

        const confirmed = await this.phoneConfirmationModal.open();

        if (confirmed) {
            this.shippingPhoneInput.setUserForcedValid();
            this.element.trigger('submit');
        } else {
            console.log('Double-check phone number');
        }
		
		return false;
	}

    async postFromCart(postData) {
        const cartRes = await this.postToServer(postData);
        if (cartRes) {
            this.onSyncResponse(cartRes);
        }
        return cartRes;
    }

    /**
     * @param isInitialLoad boolean
     */
	async syncCartWithServer(isInitialLoad) {
        let postData = {
            action: isInitialLoad ? 'load' : 'save-address'
        }
        if (!isInitialLoad) {
            postData.data = this.element.serialize();
        }
        const cartRes = await this.postToServer(postData);
        if (cartRes) {
            this.onSyncResponse(cartRes);
        }
    }

    /**
     * @param res ServerReturnData
     */
    onSyncResponse(res) {
		if (res.errors) {
            return;
        }
        if (this.cart) {
            this.cart.onCartUpdateResponse(res);
        }

        this.updateShippingDataFromServer(res);

        if (!res.destination) {
            return;
        }

        const countryName = this.shippingCountrySelect.find('option:selected').text();

        if (!res.destination.supported) {
            this.destinationNotAvailableModal.openDestinationNotAvailable(countryName);
        }
        if (res.destination.exclusiveDistributor) {
            this.destinationNotAvailableModal.openExclusiveDistributor(countryName, res.destination.exclusiveDistributor.name, res.destination.exclusiveDistributor.website);
        }

        this.couriersVaryPerPostCodePrefix = res.destination.couriersVaryPerPostCodePrefix;

        this.shippingPostalCodeInput.prop('required', res.destination.postalCodeRequired);
        // the input and its label share a wrapper; customers fill a visible field even when it is optional
        this.shippingPostalCodeInput.parent().toggle(res.destination.postalCodeRequired);
        if (!res.destination.postalCodeRequired) {
            this.shippingPostalCodeInput.val('');
        }
	}

    handlePostErrorFromServer(res) {
        let distributorError;
        const countryName = this.shippingCountrySelect.find('option:selected').text();
        if (res.errors && res.errors.length > 0 && (distributorError = res.errors.find(obj => { return obj.code === BaseCheckout.VALIDATION_ERROR_EXCLUSIVE_DISTRIBUTOR; }))) {
            this.destinationNotAvailableModal.openExclusiveDistributor(countryName, distributorError.distributor.name, distributorError.distributor.website);
        } else if (res.errors && res.errors.length > 0 && res.errors[0].code === BaseCheckout.VALIDATION_ERROR_SHIPPING_ADDRESS_UNSUPPORTED_COUNTRY) {
            this.destinationNotAvailableModal.openDestinationNotAvailable(countryName);
        } else {
            super.handlePostErrorFromServer(res);
        }
    }

    /**
     * @param res ServerReturnData
     */
    updateShippingDataFromServer(res) {
        if (this.shippingDataContainer.length === 0 ) {
            return;
        }
        this.shippingDataContainer.empty();
        let couriersRadioButtonsHtml = '<div class="courier-options">';
        for (let idx in res.couriersData) {
            let courier = res.couriersData[idx];
            couriersRadioButtonsHtml += '<div class="cbcontainer">' +
                '<input type="radio" name="courier" value="' + courier.code + '" id="courier-' + courier.code + '" ' + (courier.selected ? 'checked' : '') + ' />' +
                '<label for="courier-' + courier.code + '">' + courier.name + '</label>' +
                '</div>';
        }
        couriersRadioButtonsHtml += '</div>';
        this.shippingDataContainer.html(
            couriersRadioButtonsHtml +
            '<p class="shipping-terms">' + res.shippingTermsText.replace('\n', '<br/>') + '</p>'
        );
    }

	async getSubmitValidationErrors() {
		if (!(await this.checkPhoneNumberValid())) {
			return [this.shippingPhoneInput.input];
		}
		return super.getSubmitValidationErrors();
	}
}